
import fr from "./fr.json";
import en_UK from "./en.json";

type PaymentMethod = {
    label: string;
}

export type Labels = {
    logo: string;
    name: string;
    lang: string;
    rivtn: string;
    timezone: string;
    time_keeping: {
        d: string;
        h: string;
        m: string;
        s: string;
    },
    common: {
        back: string;
        next: string;
        cancel: string;
        success: string;
        pay_now: string;
        validate: string;
        continue: string;
        simulate: string;
        try_again: string;
        cancelled: string;
        thank_you: string;
        fully_paid: string;
        partially_paid: string;
        confirm_payment: string;
        complete_payment: string;
        back_to_business: string;
        no_payment_found: string;
        payment_successful: string;
        confirming_payment: string;
        confirm_payment_again: string;
        partially_paid_cannot_accept_payment: string;
    },
    error: {
        error: string;
        cancel: string;
        error_occur: string;
        txn_expired: string;
        missing_bak: string;
        missing_params: string;
        no_payment_methods: string;
    };
    loading: {
        loader_alt: string;
    };
    simulator: {
        back: string;
        close: string;
        success: string;
        failure: string;
        successful: string;
    };
    compound: {
        details: {
            tax: string;
            pay: string;
            tid: string;
            title: string;
            country: string;
            service: string;
            currency: string;
            discount: string;
            amount_paid: string;
            description: string;
            total_amount: string;
            txn_expire_in: string;
            request_amount: string;
        },
        payment_methods: {
            ussd: PaymentMethod;
            card: PaymentMethod;
            wallet: PaymentMethod;
            gift_card: PaymentMethod;
            mobile_money: PaymentMethod;
            bank_transfer: PaymentMethod;
        };
    };
    method: {
        card: {
            title: string;
            opt_sent: string;
            enter_pin: string;
            enter_otp: string;
            card_info: string;
            card_desc: string;
            resend_otp: string;
            server_error: string;
            unknown_error: string;
            enter_card_pin: string;
            enter_sent_otp: string;
            otp_placeholder: string;
            card_holder_name: string;
            card_input_invalid: string;
            use_test_otp_codes: string;
            card_expired_error: string;
            card_no_placeholder: string;
            invalid_card_number: string;
            card_cvv_placeholder: string;
            card_holder_name_desc: string;
            card_name_placeholder: string;
            card_expiry_placeholder: string;
            insufficient_funds_error: string;
            card_holder_name_required: string;
        };
        ussd: {
            desc: string;
            title: string;
            search: string;
            select_bank: string;
            choose_bank: string;
            simply_dial: string;
            enter_ussd_code: string;
            ussd_code_copied: string;
        };
        wallet: {
            desc: string;
            title: string;
            search: string;
            select_wallet: string;
            choose_wallet: string;
            payment_failed_try_again: string;
        };
        bank_transfer: {
            title: string;
            bank_name: string;
            account_name: string;
            account_number: string;
            fetching_details: string;
            account_number_copied: string;
        };
        gift_card: {
            desc: string;
            title: string;
            gift_card_number: string;
            enter_gift_card_number: string;
        };
        mobile_money: {
            title: string;
            instruction: string;
            phone_number: string;
            phone_number_desc: string;
            enter_phone_number: string;
            choose_mobile_network: string;
            select_mobile_network: string;
            choose_mobile_network_desc: string;
            countries: {
                code: string;
                icon: string;
                dial_code: string;
                placeholder: string;
            }[];
        }
    };
};

export type LanguageMap = { [key: string]: Labels };

const languages: LanguageMap = {
    fr,
    en_UK,
};

let i18nData: Labels;
const urlSearchParams = new URLSearchParams(window.location.search);
let defaultLanguage: string = (urlSearchParams.get("lang") ?? "en_UK");

export const i18nManager = {

    Labels: i18nData!,
    LabelsLoaded: false,
    ActiveLanguage: defaultLanguage,
    Languages: [
        {
            label: "EN",
            value: "en_UK"
        },
        {
            label: "FR",
            value: "fr"
        }
    ],
    CountriesAndCurrencies: [
        {
            value: "NGA",
            label: "Nigeria",
            currency_sign: "₦",
            currency_code: "NGN",
            currency_name: "Naira",
            icon: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/79/Flag_of_Nigeria.svg/260px-Flag_of_Nigeria.svg.png",
        },
        {
            value: "GHA",
            label: "Ghana",
            currency_sign: "₵",
            currency_code: "GHS",
            currency_name: "Cedi",
            icon: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/19/Flag_of_Ghana.svg/250px-Flag_of_Ghana.svg.png",
        }
    ],

    switchLanguage(lang: string) {
        urlSearchParams.set("lang", lang);
        window.location.search = urlSearchParams.toString();
    }

};

if (!i18nManager.LabelsLoaded) {
    i18nData = languages[defaultLanguage.replace('-', '_')] || languages["en_UK"];
    i18nData.timezone = defaultLanguage;
    i18nManager.Labels = i18nData;
    i18nManager.LabelsLoaded = true;
}